export default __webpack_public_path__ + "static/logohero-99239863ca97ccb69de3be3853c426c4.png";